import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "./utils-provider.service";
import { isPlatformBrowser } from "@angular/common";

@Injectable(
    {
        providedIn: 'root'
    }
)
export class KeyValueStorage {
  public static STORE_MEMORY = 'memory';
  public static STORE_SESSION = 'session';
  public static STORE_LOCAL = 'local';
  private memoryStore: { [key: string]: any } = {};
  private stores: { [storeType: string]: { [key: string]: any } } = {};
  private isBrowser: boolean = false;

  constructor(
    private configProvider: ConfigProvider,
    @Inject(PLATFORM_ID) private platformId: Object
) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.initialize();
    }

    public get(key: string, fallback: any = null, store: string = this.configProvider.defaultKeyValueStore): any {
        try {
          const value = this.stores[store][key];
          if (value === null || value === undefined) {
              return fallback;
          }
          return value;
        } catch (e) {
          return fallback;
        }
    }

    public set(key: string, value: any, store: string = this.configProvider.defaultKeyValueStore): void {
        this.stores[store][key] = value;
    }

    public remove(key: string, store: string = this.configProvider.defaultKeyValueStore): void {
        delete this.stores[store][key];
    }

  public clear(store: string): void {
    if (store === KeyValueStorage.STORE_MEMORY) {
      this.memoryStore = {};
    } else if (store === KeyValueStorage.STORE_SESSION && this.isBrowser) {
      window.sessionStorage.clear();
    } else if (store === KeyValueStorage.STORE_LOCAL && this.isBrowser) {
      window.localStorage.clear();
    }

    this.stores[KeyValueStorage.STORE_MEMORY] = this.memoryStore;
    // Conditionally set these only if in a browser environment
    if (this.isBrowser) {
      this.stores[KeyValueStorage.STORE_SESSION] = window.sessionStorage;
      this.stores[KeyValueStorage.STORE_LOCAL] = window.localStorage;
    }
  }

  private initialize(): void {
    this.stores[KeyValueStorage.STORE_MEMORY] = this.memoryStore;
    if (this.isBrowser) {
      this.stores[KeyValueStorage.STORE_SESSION] = window.sessionStorage;
      this.stores[KeyValueStorage.STORE_LOCAL] = window.localStorage;
    }
  }
}
